import type { CSSProperties } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import tourContent from 'productTours/demoTour/DemoTourContent';

interface TourStep {
  position?: 'center' | 'top' | 'right' | 'bottom' | 'left';
  selector?: string;
  content: React.ReactNode;
  action?: () => void;
  styles?: {
    maskArea?: (base: CSSProperties) => CSSProperties & { rx?: number };
    [key: string]:
      | ((base: CSSProperties) => CSSProperties & { rx?: number })
      | undefined;
  };
  stepInteraction?: boolean;
  disableWhenSelectorFalsy?: boolean;
}

interface TranslatedContentProps {
  contentKey: string;
}

const TranslatedContent: React.FC<TranslatedContentProps> = ({
  contentKey,
}) => {
  const { t } = useTranslation('productTour');

  return <>{tourContent[contentKey](t)}</>;
};

export default function demoTourSteps(
  hideHighlight,
  showSidePanel: (show?: boolean) => void
): TourStep[] {
  return [
    {
      position: 'center',
      content: <TranslatedContent contentKey="step1" />,
      styles: hideHighlight,
      stepInteraction: false,
    },
    {
      position: 'center',
      content: <TranslatedContent contentKey="step2" />,
      styles: hideHighlight,
      action: () => showSidePanel(true),
    },
    {
      selector: '.demo-tour-step-5',
      content: <TranslatedContent contentKey="step5" />,
      action: () => showSidePanel(true),
      stepInteraction: false,
    },
    {
      selector: '.demo-tour-step-6',
      content: <TranslatedContent contentKey="step6" />,
      action: () => showSidePanel(false),
      stepInteraction: false,
    },
    {
      selector: '.demo-tour-step-8',
      content: <TranslatedContent contentKey="step8" />,
      stepInteraction: false,
      action: () => showSidePanel(true),
    },
    {
      position: 'center',
      content: <TranslatedContent contentKey="step9" />,
      action: () => showSidePanel(false),
      stepInteraction: false,
      styles: hideHighlight,
    },
    {
      selector: '.demo-tour-step-10',
      content: <TranslatedContent contentKey="step10" />,
      action: () => showSidePanel(false),
      disableWhenSelectorFalsy: true,
    },
  ];
}
